// src/pages/Dashboard.js
import React, { useState } from "react";
import Areas from "./Areas";
import UserManagement from "./UserManagement";
import { useTranslation } from "react-i18next";
import Notification from "./Notification";
import { useSite } from "../context/SiteContext";
import Statistics from "./Statistics";

function Dashboard() {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const { selectedSite, setsiteId, sites, loadingSites } = useSite();

  const handleSiteChange = (site) => {
    setsiteId(site.id);
    localStorage.setItem("siteId", site.id);
    localStorage.setItem("actualUserRole", site.user_role);
  };

  return (
    <div className="container mt-4">
      {sites.length > 1 && (
        <div className="d-flex gap-2 mb-4" style={{ overflowX: 'auto', paddingBottom: 2 }}>
          {sites.map(site => {
            const isSelected = selectedSite?.id === site.id;
            return (
              <button
                key={site.id}
                onClick={() => handleSiteChange(site)}
                className="flex-shrink-0 site-pill"
                style={{
                  border: isSelected ? '2px solid #e8600a' : '1px solid #dee2e6',
                  background: isSelected ? '#e8600a' : undefined,
                  color: isSelected ? '#fff' : 'inherit',
                  borderRadius: 20,
                  padding: '5px 14px',
                  cursor: 'pointer',
                  fontWeight: isSelected ? 600 : 400,
                  fontSize: '0.875rem',
                  whiteSpace: 'nowrap',
                  transition: 'background 0.15s, border-color 0.15s, color 0.15s',
                }}
              >
                {site.name}
              </button>
            );
          })}
        </div>
      )}

      {/* 🧩 Content below */}
      <div className="row g-4 align-items-start">
        {/* Left: Areas */}
        <div className="col-12 col-lg-6">
          {selectedSite ? (
          <><Areas site={selectedSite} />
          <br></br>
              {selectedSite?.user_role != 'gate_opener' && <Statistics />}</>
          ) : (
            <p>{t('Please select a site.')}</p>
          )}
        </div>

        
        {/* Right: User Management */}
        {selectedSite?.user_role != 'gate_opener' && (
          <div className="col-12 col-lg-5">
            <UserManagement selectedSite={selectedSite} compact={true} />
          </div>)}
      </div>

      <Notification message={errorMessage} type="danger" onClose={() => setErrorMessage("")} />
      <Notification message={successMessage} type="success" onClose={() => setSuccessMessage("")} />
    </div>
  );
}

export default Dashboard;
